module.exports = __webpack_public_path__ + "aad82ea0b51725409da1bfc6dd76da0e.pdf";